import styled from 'styled-components'

// Shared login page styles for LoginAdmin and LoginManager
const LoginStyles = {
	Wrapper: styled.main`
		height: 100%;
		min-height: 100dvh;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 20px;
		box-sizing: border-box;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			padding: 16px;
			justify-content: flex-start;
			padding-top: 10vh;
		}

		@media (max-width: 480px) {
			padding: 12px;
			padding-top: 8vh;
		}
	`,

	ContentDiv: styled.div`
		width: fit-content;
		max-width: 100%;
		height: fit-content;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 80px;
		background-color: ${({theme}) => theme.color.white};
		border-radius: 20px;
		padding: 96px 64px;
		box-sizing: border-box;

		& > h2 {
			${({theme}) => theme.font.large_bold}
		}

		/* Mobile responsive styles */
		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			gap: 24px;
			padding: 32px 24px;
			border-radius: 16px;
			width: 100%;
			max-width: 360px;
		}

		@media (max-width: 480px) {
			gap: 20px;
			padding: 24px 20px;
			border-radius: 12px;
			max-width: 320px;

			& > h2 {
				${({theme}) => theme.font.medium_bold};
				text-align: center;
			}
		}
	`,

	FormDiv: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 32px;
		width: 432px;
		background-color: ${({theme}) => theme.color.white};

		/* Mobile responsive styles */
		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			width: 100%;
			max-width: 320px;
			gap: 20px;
		}

		@media (max-width: 480px) {
			width: 100%;
			gap: 16px;
			max-width: 280px;
		}
	`,

	BtnDiv: styled.div`
		display: flex;
		flex-direction: column;
		align-items: end;
		gap: 12px;

		/* Mobile responsive styles */
		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			align-items: center;
			width: 100%;
			gap: 12px;
		}

		@media (max-width: 480px) {
			gap: 10px;

			& > button {
				width: 100%;
				min-width: auto;
				padding: 10px 0;
			}
		}
	`,

	// LoginManager-specific components
	AdminLoginBtn: styled.button`
		width: fit-content;
		margin-bottom: 20px;
		${({theme}) => theme.font.extra_small};

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			margin-bottom: 16px;
		}

		@media (max-width: 480px) {
			margin-bottom: 12px;
			width: 100%;
			text-align: center;
		}
	`,

	ControlDiv: styled.div`
		display: flex;
		justify-content: space-between;

		& > button {
			${({theme}) => theme.font.small};
		}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			width: 100%;
			gap: 16px;
		}

		@media (max-width: 480px) {
			flex-direction: column;
			gap: 8px;
			align-items: center;

			& > button {
				${({theme}) => theme.font.extra_small};
			}
		}
	`,
}

export default LoginStyles
